<template>
  <div class="audio-player">
    <img v-if="hasPreview" :src="preview" class="preview" v-on:click="play()" :title="tooltip">
    <audio class="audio-control" controls :autoplay="autoplay">
      <source v-for="uri in uris" :src="uri.src" :type="uri.mimetype" :key="uri.id">
    </audio>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      playing: false,
      tooltip: "Play"
    };
  },
  props: {
    media: {
      type: Object
    }
  },
  computed: {
    id() {
      let id = "--";
      if (this.media.id) {
        id = this.media.id;
      }
      return id;
    },
    autoplay() {
      if (this.media.autoplay) {
        return true;
      } else {
        return false;
      }
    },
    preview() {
      let preview = "";
      if (this.media.preview) {
        preview = this.media.preview;
      }
      return preview;
    },
    hasPreview() {
      return this.preview.length > 5;
    },
    uris() {
      let uris = [];
      let index = 0;
      if (this.media.src) {
        uris.push({
          src: this.media.src,
          mime: this.mime,
          id: this.id
        });
      } else if (this.media.uris) {
        if (this.media.uris instanceof Array) {
          uris = this.media.uris.map((u, i) => {
            u.id = this.id + "-" + i;
          });
        }
      }
      return uris;
    }
  },
  methods: {
    play() {
      const audioEl = this.$el.querySelector("audio");
      if (audioEl) {
        if (audioEl.paused) {
          audioEl.play();
          this.tooltip = "Pause";
        } else {
          audioEl.pause();
          this.tooltip = "Play";
        }
      }
    },
    changeState() {
      setTimeout(() => {
        const audioEl = this.$el.querySelector("audio");
        if (audioEl) {
          this.tooltip = audioEl.paused ? "Play" : "Pause";
        }
      }, 50);
    }
  }
};
</script>